import type { ProjectTime } from "../components/Timing";
import {
	type EntryForDisplay,
	type EntryRequest,
	EntryRequestFromEntryDisplay,
	EntryRequestFromProjectTime,
	type EntryResponse,
} from "../interfaces/CapsuleEntry";
import type { UserDetails } from "../interfaces/UserDetails";
import { API } from "./BaseAPI";

export async function PostCapsuleEntry(
	t: ProjectTime,
	projectID: string,
	user: UserDetails,
) {
	const body: { entry: EntryRequest } = {
		entry: EntryRequestFromProjectTime(projectID, t, user),
	};

	const res = await API().post("/entries/", body, {
		method: "POST",
	});

	return res;
}

export async function PutCapsuleEntry(id: number, e: EntryForDisplay) {
	const entry = EntryRequestFromEntryDisplay(e);

	const body: { entry: EntryRequest } = {
		entry: entry,
	};

	const res = await API().put(`/entries/${id}`, body, {
		method: "PUT",
	});

	return res;
}

export function GetCapsuleEntries(project: number, pageNumber: number) {
	const response: {
		entries: EntryResponse[];
		hasNextPage: boolean;
	} = {
		entries: [],
		hasNextPage: false,
	};

	return API()
		.get(
			`/kases/${project}/entries?embed=creator,activityType&page=${pageNumber}`,
			{
				method: "GET",
			},
		)
		.then((res) => {
			const r = res.data.entries as EntryResponse[];
			response.entries = [...response.entries, ...r];

			if (res.headers.link != null) {
				response.hasNextPage = res.headers.link.includes('rel="next"');
			}

			return response;
		});
}

export function GetCapsuleEntriesByDate(pageNumber: number) {
	const response: {
		entries: EntryResponse[];
		hasNextPage: boolean;
	} = {
		entries: [],
		hasNextPage: false,
	};

	return API()
		.get(`/entries?embed=creator,activityType,kase,party&page=${pageNumber}`, {
			method: "GET",
		})
		.then((res) => {
			const r = res.data.entries as EntryResponse[];
			response.entries = [...response.entries, ...r];

			if (res.headers.link != null) {
				response.hasNextPage = res.headers.link.includes('rel="next"');
			}

			return response;
		});
}

export async function DeleteCapsuleEntry(entry: number) {
	return API().delete(`/entries/${entry}`, {
		method: "DELETE",
	});
}
